import { lazy } from 'react';
import modules from '@src/service/modules';
import { element } from 'prop-types';

const BrandMaster = lazy(() => import('../../views/Master/BrandMaster/index'));
const Category = lazy(() => import('../../views/Master/Category/index'));
const SubCategory = lazy(() => import('../../views/Master/SubCategory/index'));
const Item = lazy(() => import('../../views/Master/Item/index'));
const Unit = lazy(() => import('../../views/Master/UnitMaster/index'));
const Material = lazy(() => import('../../views/Master/Material/index'));
const MaterialCategory = lazy(() => import('../../views/Master/MaterialCategory/index'));
const MaterialSubCategory = lazy(() => import('../../views/Master/MaterialSubCategory/index'));
const Supplier = lazy(() => import('../../views/Master/Supplier/index'));
const MixDesign = lazy(() => import('../../views/MixDesign'));
const AddMixDesign = lazy(() => import('../../views/MixDesign/component/AddMixDesign'));
const StructureType = lazy(() => import('../../views/Master/StructureType/index'));
const StructureActivity = lazy(() => import('../../views/Master/StructureActivity/index'));
const ItemsMixture = lazy(() => import('../../views/Master/ItemsMixture/index'));
const ItemsMixtureAdd = lazy(() => import('../../views/Master/ItemsMixture/component/AddItemsMixture'));
const Forms = lazy(() => import('../../views/Master/Forms'));
const Machinery = lazy(() => import('../../views/Master/Machinery'));
const MachineryType = lazy(() => import('../../views/Master/MachineryType'));
const AdjustmentType = lazy(() => import('../../views/Master/AdjustmentType'))

const MasterRoutes = [
    {
        path: '/master/category/item',
        element: <Category />
    },
    {
        path: '/master/subcategory/item',
        element: <SubCategory />
    },
    {
        path: '/master/item',
        element: <Item />
    },
    {
        path: '/master/subcategory/material',
        element: <MaterialSubCategory />
    },
    {
        path: '/master/category/material',
        element: <MaterialCategory />
    },
    {
        path: '/master/material',
        element: <Material />
    },
    {
        path: '/master/mix-design',
        element: <MixDesign />
    },
    {
        path: '/master/mix-design/add',
        element: <AddMixDesign />
    },
    {
        path: '/master/mix-design/edit/:id',
        element: <AddMixDesign />
    },
    {
        path: '/master/supplier',
        element: <Supplier />
    },
    {
        path: '/master/brand',
        element: <BrandMaster />
    },
    {
        path: '/master/unit',
        element: <Unit />
    },
    {
        path: '/master/structure/type',
        element: <StructureType />
    },
    {
        path: '/master/structure/activity',
        element: <StructureActivity />
    },
    {
        path: '/master/mixture-items',
        element: <ItemsMixture />
    },
    {
        path: '/master/mixture-items/add',
        element: <ItemsMixtureAdd />
    },
    {
        path: '/master/mixture-items/edit/:id',
        element: <ItemsMixtureAdd />
    },
    {
        path: '/master/mixture-items/view/:id',
        element: <ItemsMixtureAdd />
    },
    {
        path: '/master/machinery-type',
        element: <MachineryType />
    },
    {
        path: '/master/machineries',
        element: <Machinery />
    },
    {
        path: '/master/adjustment',
        element: <AdjustmentType />
    },
    {
        path: '/master/forms',
        element: <Forms />
    }
];

export default MasterRoutes;
